import {t} from '../../../../common/getTranslations';
import {
  TicketKind,
  TicketSum,
  TicketType,
} from '../../../../graphql/generated/types';

export function getFreeTicketDialogInfoFunction(freeTicketList: TicketSum[]) {
  if (freeTicketList.length === 0) {
    return {};
  }
  let rentSum = 0;
  let buySum = 0;
  const ticketTypeList: TicketType[] = [];
  let _ticketExpireAt: string | undefined;

  freeTicketList.forEach(({ticketType, ticketKind, count}) => {
    if (ticketKind === TicketKind.Rent) {
      rentSum += count;
    } else {
      buySum += count;
    }
    if (!ticketTypeList.includes(ticketType)) {
      ticketTypeList.push(ticketType);
    }
  });
  freeTicketList.forEach(({ticketExpireAt}) => {
    // 무료 이용권이 여러 장일 경우, 유효기간은 가장 최근 날짜를 보여줍니다.
    if (ticketExpireAt) {
      if (_ticketExpireAt) {
        _ticketExpireAt =
          new Date(ticketExpireAt) < new Date(_ticketExpireAt)
            ? ticketExpireAt
            : _ticketExpireAt;
      } else {
        _ticketExpireAt = ticketExpireAt;
      }
    }
  });

  const highlightTexts = [];
  if (rentSum > 0) {
    highlightTexts.push(
      t('ticket_purchase_confirmation_popup_rental_count', {
        values: {value: rentSum},
      })
    );
  }
  if (buySum > 0) {
    highlightTexts.push(
      t('ticket_purchase_confirmation_popup_possission_count', {
        values: {value: buySum},
      })
    );
  }
  return {
    openDialog: true,
    title:
      ticketTypeList.length === 1 &&
      NEW_CUSTOMER_GIFT_TICKET_LIST.includes(ticketTypeList[0])
        ? t('contenthome_free_ticket_popup_title')
        : t('contenthome_gift_popup_title'),
    highlight: highlightTexts.join(', '),
    rentSum,
    buySum,
    expireAt: _ticketExpireAt,
    ticketTypeList,
  };
}

const NEW_CUSTOMER_GIFT_TICKET_LIST = [
  TicketType.BuyNewCustomerGift,
  TicketType.RentNewCustomerGift,
];
